'use strict';

var replaceCmsKeyArgs = Odigeo.Utils.replaceCmsKeyArgs;
var viewInjector = require('./view_injector');

var template = function(text) {
    return Odigeo._.template(text, Odigeo.Utils.getTmplSettings({variable: ''}));
};

var tagsKeyArgs = {
    time: ['{{ index }}', '{{ minDepartureDate }}', '{{ maxDepartureDate }}'],
    stopoverQuantity: ['{{ maxStopoversSelected }}'],
    stopoverDuration: ['{{ selectedStopDuration }}'],
    airports: ['{{ cityName }}'],
    airlines: [],
};

var initTemplates = function() {
    var templates = Odigeo._.reduce(tagsKeyArgs, Odigeo._.bind(function(templates, keyArgs, prop) {
        templates[prop] = Odigeo._.flow(template(replaceCmsKeyArgs.apply(null, [this.keys[prop]].concat(keyArgs))),
            Odigeo.Utils.pluralizeAll);
        return templates;
    }, this), {});
    Odigeo._.extend(this.templates, templates);
};

Odigeo.defineWidget('flights_filters_summary', Odigeo.Widget.extend({
    viewClass: Odigeo.View.extend({
        init: function() {
            this.widget.options = Odigeo.Utils.parseOptions(this.widget.options);
            initTemplates.call(this);
            viewInjector(this).create('container').render();
        },
        dpResumeNumResults: function({numFilteredResults, numResults, isFiltering} = {}) {
            viewInjector(this).create('container').dpResumeNumResults(numFilteredResults, numResults, isFiltering);
        },
    }),

    dpResumeNumResults: function(...args) {
        this.view.dpResumeNumResults(...args);
    },
}));
